import React from "react";
import LitText from "./LitText";
import Reveal from "../Reveal";
import SectionIntro from "./SectionIntro";
import { WHO } from "../../data/about";

/**
 * One sentence, given room.
 *
 * The statement is the heading here, so the intro carries only the label and
 * the sentence itself lights up as it is read. The two notes underneath sit in
 * a plain two-column bed with a single small offset between them — enough to
 * keep the block from reading as a table, not so much that the page starts
 * looking like it was assembled from spare parts.
 */

function WhoWeAre() {
  return (
    <section id="who" className="scroll-mt-24 bg-[#FAF8F2] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <Reveal>
          <SectionIntro index={WHO.index} label={WHO.label} />
        </Reveal>

        <LitText
          as="p"
          text={WHO.statement}
          className="mw-display mt-10 max-w-4xl text-[#1E1B16]"
        />

        <div className="mt-16 grid grid-cols-1 gap-10 sm:grid-cols-2 sm:gap-14 lg:mt-20">
          {WHO.aside.map((note, i) => (
            <Reveal key={note.heading} delay={i * 120} className={i === 1 ? "sm:mt-12" : ""}>
              <div className="border-t border-[#1E1B16]/15 pt-6">
                <span className="mw-eyebrow text-[#6A0DAD]">{note.heading}</span>
                <p className="mw-lede mt-4 max-w-md text-[#4D4B46]">{note.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhoWeAre;
